import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User, UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { Observable } from 'rxjs';
import { identityServerAngularConfig } from '@env/environment';

import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { RealTimeNotificationService } from '@shared/services/realTimeNotification/real-time-notification.service';
import { SignalrService } from '@app/core/signalr.service';
import { environment } from '@env/environment';
import { ToastService } from '@shared/services/toast/toast.service';
import { NgxPermissionsService, NgxPermissionsObject } from 'ngx-permissions';
import { MyStartupService } from '@app/app.service';
import { LoaderService } from '@app/core/loader.service';
import { NotificationsService } from '@shared/services/notifications.service';
import { HttpClient } from '@angular/common/http';
import { AuthServiceCleaner } from '@shared/services/auth.service.cleaner';
import { IdleTimeoutService } from '@shared/services/idle-timeout.service';
import { guid } from '@app/core/helpers';
import { Constants } from '@app/constants';
import { ThemesService } from '@projects/shared/src/app/features/setting/services/themes.service';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import jwtDecode from 'jwt-decode';
import { MFATypes } from '@projects/agent/src/app/models/userprofile';
import { MFAFlags } from '@projects/shared/src/app/enums/MFAFlags';
import { RealTimeEvents } from '@app/core/signalr.events';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  identity$!: Observable<User>;
  loggedIn$!: Observable<boolean>;
  loading$!: Observable<boolean>;
  expiring$!: Observable<boolean>;
  expired$!: Observable<boolean>;
  errors$!: Observable<any>;
  public isLoggedIn!: boolean;
  public identity!: any;
  error!: string;
  permissions!: NgxPermissionsObject;
  public userProfile: KeycloakProfile | null = null;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private signalRService: SignalrService,
    private idleTimeoutService: IdleTimeoutService,
    private route: ActivatedRoute,
    private ngxpermissions: NgxPermissionsService,
    private myStartupService: MyStartupService,
    private loaderService: LoaderService,
    private themeService: ThemesService,
    private notificationsService: NotificationsService, // private i18nService: I18nService
    private keycloak: KeycloakService
  ) {}

  async ngOnInit() {
    // this.initLogin();
    //this.checkIsIdletimeoutSet();
    await this.checkIsTokenExpired();
  }

  async checkIsTokenExpired() {
    let isTokenExpired = JSON.parse(localStorage.getItem('isTokenExpired') || 'null');
    if (isTokenExpired && isTokenExpired == true) {
      //window.localStorage.clear();
      this.authService.signoutRedirect();
      return;
    } else {
      await this.checkTenantName();
    }
  }

  // checkIsIdletimeoutSet() {
  //   let isIdleTimeout = JSON.parse(localStorage.getItem('isIdleTimeout') || 'null');
  //   let isUserReloggedIn = JSON.parse(localStorage.getItem('isUserReloggedIn') || 'null');
  //   if (isIdleTimeout && isIdleTimeout == true) {
  //     window.localStorage.clear();
  //     this.authService.signoutRedirect();
  //     return;
  //   } else if (isUserReloggedIn && isUserReloggedIn == true) {
  //     localStorage.removeItem('isUserReloggedIn');
  //     this.router.navigate(['/post-logout']);
  //   }
  // }

  async checkTenantName() {
    let tenantName = this.route.snapshot.paramMap.get('id');
    if (!tenantName && this.authService.authData == null) {
      if (environment.login.isDefaultEnabled) {
        tenantName = environment.login.defaultRouteValue;
      }
    }
    if (tenantName) {
      if (this.authService.authData == null) {
        if (this.authService.getTenantName() == null || tenantName !== this.authService.getTenantName()) {
          localStorage.setItem('tenant', tenantName);
        }
        this.authService.init();
        this.initLogin();
      } else {
        this.authService.init();
        this.initLogin();
      }
    } else {
      localStorage.setItem('tenant', '');
      this.authService.init();
      this.initLogin();
    }
  }

  async initLogin() {
    this.loaderService.showMain = true;
    //this.checkIsIdletimeoutSet();

    if (await this.authService.isUserLoggedIn()) {
      // this.authService.checkTokenExpiry(user.expires_at);
      this.isLoggedIn = true;
      this.authService.isLoggedIn = true;
      this.keycloak.loadUserProfile().then((user: any) => {
        this.identity = user;
        this.keycloak.getToken().then((token: any) => {
          let userId = localStorage.getItem('enableTwoFactor');
          if (userId) {
            this.authService.syncTwoFactor(userId).subscribe(() => {
              this.initUser(token);
            });
          } else {
            this.initUser(token);
          }
        });
      });
    } else {
      this.isLoggedIn = false;
      this.authService.isLoggedIn = false;
      this.identity = '';
      if (this.authService.isSetLoggedOut === false) {
        this.authService.clearAuthData();
        localStorage.removeItem('isSSOLogin');
        localStorage.removeItem('ssoClient');
        localStorage.removeItem('ssoToken');
        localStorage.removeItem('isIdleTimeout');
        localStorage.removeItem('idle_timeout_enabled');
        this.authService.signinRedirect();
      } else {
        //this.router.navigate(['/unauthorized']);
        this.router.navigate(['/post-logout']);
      }
    }
  }

  login() {
    this.authService.login();
  }

  initUser(token: string) {
    console.log(new Date().toLocaleString() + '  ➤  init user login component');
    let tokenDecoded: any;
    const isRedirectFromMultiAuthPage = localStorage.getItem('isRedirectFromMultiAuthPage');
    if (token) tokenDecoded = jwtDecode(token);
    if (!isRedirectFromMultiAuthPage) {
      var mfaFlow = this.initMfaVerificationFlow(tokenDecoded);
      if (mfaFlow) return;
    }

    const res = {
      access_token: token,
      expiry: tokenDecoded?.exp,
    };

    this.authService.storeAuthData(res).subscribe(
      (response) => {
        this.authService.onSignIn(response);
        if (response && response.IdleTimeoutConfig != null && response.IdleTimeoutConfig.IsIdletimeoutEnabled) {
          this.idleTimeoutService.setIdletimeout(response.IdleTimeoutConfig.TimeoutSeconds);
        }

        if (environment.signalRConfigured) {
          //this.signalRService.init();
          // this.realTimeNotificationService.init();
          //this.realTimeNotificationService.subscribeListeners();
        }
        this.authService.getLanguage().subscribe((langResponse) => {
          this.myStartupService.data = langResponse;
          // localStorage.setItem('translations', JSON.stringify(langResponse));
          localStorage.setItem('translations', JSON['makeStringify'](langResponse));
          this.permissions = this.ngxpermissions.getPermissions();
          const Admin = this.permissions['Admin'] ? true : false;
          const Reporting = this.permissions['Reporting'] ? true : false;

          this.loaderService.showMain = false;
          if (localStorage.getItem('loginNotificationId') == null) {
            const id: string = guid();
            localStorage.setItem('appNotifyId', id);
            const notifyData = { message: 'Login Successful', pageName: 'Login', module: 'Login', appNotifyId: id };
            this.notificationsService.ActivityNonRequestNotification(notifyData, true);
          }
          // const isAdmin = response?.Admin;
          // const isAgent = response?.Agent;
          // const isSupervisor = response?.Supervisor;
          // const isQA = !response?.Admin && !response?.Agent && !response?.Supervisor;
          const isAdmin = response?.PrimaryApp === 'Backstage';
          const isAgent = response?.PrimaryApp == 'ConnectHub';
          const isSupervisor = response?.PrimaryApp === 'Sightline';
          const isQA = response?.PrimaryApp === 'QA';
          //response?.QA;

          // if(this.authService.authData.mfaNotAllow){
          //   this.router.navigate(['/mfa-notsupported']);
          //   return;
          // }
          //  Check if two factor recovery code is generated then we need to show recovery code screen...
          if (this.authService.authData.RecoveryCode) {
            this.router.navigate(['/recovery-code']);
            return;
          }

          if (isAgent) {
            this.authService.agentDefaultUrl();
            console.log(new Date().toLocaleString() + '  ➤  Routing to default page', Constants.Apps.Agent.defaultPath);
            this.router.navigate([Constants.Apps.Agent.defaultPath]);
          } else if (isSupervisor) {
            this.authService.QADefaultUrl();
            this.router.navigate([Constants.Apps.Supervisor.defaultPath]);
          } else if (Reporting) {
            this.router.navigate(['/' + environment.reportingRoutePrefix]);
          } else if (isAdmin) {
            this.authService.backstageDefaultUrl();
            this.router.navigate([Constants.Apps.Admin.defaultPath]);
          } else if (isQA) {
            this.authService.QADefaultUrl();
            this.router.navigate([Constants.Apps.QA.defaultPath]);
          } else {
            this.router.navigate(['/unauthorized']);
          }
        });
        this.authService.setLoginTime();
        this.authService.addLoggedInStatus(Constants.STATUSES.LoggedIn.FriendlyName);
        this.themeService.syncSelectedTheme();
        this.sendEvent();
      },
      (reason) => {
        switch (reason.status) {
          case -1: {
            this.error = 'Some error occurred. Please check your internet connection or try again';
            this.loaderService.showMain = false;

            break;
          }
          case 400: {
            this.error = reason.Message;
            this.loaderService.showMain = false;

            break;
          }
          case 500: {
            this.error = reason.error.ExceptionMessage;
            this.loaderService.showMain = false;

            break;
          }
        }
      }
    );
  }

  private initMfaVerificationFlow(tokenDecoded: any): boolean {
    const mfa: string = tokenDecoded.MFA;

    if (mfa) {
      const mfaList = mfa.split(',').map((a) => a.trim());

      if (mfaList.some((a) => a == MFATypes[MFATypes.Email])) {
        const isEmailVerified = this.authService.isMfaChannelVerified(MFAFlags.Email);

        if (!isEmailVerified) {
          this.loaderService.showMain = false;
          this.router.navigate(['email-verification'], {
            queryParams: { id: tokenDecoded.UserId, email: this.identity.email, verified: tokenDecoded.FirstLogin },
          });

          return true;
        }
      }

      if (mfaList.some((a) => a == MFATypes[MFATypes.SMS])) {
        const isSmsVerified = this.authService.isMfaChannelVerified(MFAFlags.SMS);

        if (!isSmsVerified) {
          this.loaderService.showMain = false;
          this.router.navigate(['sms-verification'], {
            queryParams: {
              id: tokenDecoded.UserId,
              phoneNumber: tokenDecoded.PhoneNumber,
              verified: tokenDecoded.FirstLogin,
            },
          });

          return true;
        }
      }
    }

    return false;
  }
  private sendEvent() {
    if (!this.authService.authData) return;
    const SupervisorCampaignCodes = this.authService.authData.CampaignInfo.Supervisor
      ? this.getCompaignCode(this.authService.authData.CampaignInfo.Supervisor.Campaigns).join(', ')
      : '';
    const AgentCampaignCodes = this.authService.authData.CampaignInfo.Agent
      ? this.getCompaignCode(this.authService.authData.CampaignInfo.Agent.Campaigns).join(', ')
      : '';
    let clientId = this.authService.authData.ClientId;
    this.signalRService.invoke(RealTimeEvents.SendAgentStatusChangeNotification, {
      UserId: this.authService.getUserId(),
      ClientId: clientId,
      Campaigns: this.authService.getAllCampaignCode(),
      Email: this.authService.authData.Email,
      NewStatus: Constants.STATUSES.LoggedIn.FriendlyName,
      OldStatus: Constants.STATUSES.LoggedIn.FriendlyName,
      Inbound: 0,
      Outbound: 0,
      StatusTime: '0',
      LoginTime: this.authService.loginDuration,
      Role: this.authService.authData.Role,
      AssignedApps: this.authService.authData.AssignedApp,
      SupervisorCampaignCodes: SupervisorCampaignCodes,
      AgentCampaignCodes: AgentCampaignCodes,
    });
  }

  private getCompaignCode(data: Array<any>): Array<string> {
    const codes: Array<string> = [];
    data.forEach((item) => {
      codes.push(item.Code);
    });
    return codes;
  }
}
